module.exports = __webpack_public_path__ + "static/media/designCharrette_economy_header.75cbb430.jpg";